__turbopack_context__.v({
  "buttonRowsWrapper": "PMGOua_buttonRowsWrapper",
  "content": "PMGOua_content",
  "root": "PMGOua_root",
  "scrollButton": "PMGOua_scrollButton",
});
